<template>
  <i>{{ icon }}</i>
</template>

<script>
export default {
  name: "NettoIcon",
  props: {
    icon: String
  }
};
</script>
<style scoped>
i {
  font-family: "Netto Icons Regular";
  font-style: normal;
}
</style>
